module.exports = __webpack_public_path__ + "img/articalPic.73f74011.png";